<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Meter"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="page--v2 d-flex flex-column"
    v-if="loaded"
  >
    <MaterialTabs
      :tabManager="tabManager"
    >
      <ItpBox
        alignItems="center"
        class="mr-3"
        slot="tabs-start"
      >
        <b-breadcrumb
          class="m-0 bg-white"
        >
          <b-breadcrumb-item
            :text="'Meters'|gettext"
            :to="b_2285343489561581_to"
          >
          </b-breadcrumb-item>
          <b-breadcrumb-item
            :text="item.snapshot('serial_number')"
            active
          >
          </b-breadcrumb-item>
        </b-breadcrumb>
        <ItpButton
          variant="light"
          icon="fa-sync-alt"
          :tooltip="'Reload'|gettext"
          :spinning="actions.reload.isRunning"
          size="sm"
          class="mr-2"
          @click.prevent.stop="evh_2095089031469157_clickPreventStop($event, {})"
        >
        </ItpButton>
        <BtnDeleteResource
          :resource="item"
          no-text
          class="mr-2"
          @success="evh_9004123373732307_success($event, {})"
        >
        </BtnDeleteResource>
        <ItpButton
          icon="material-symbols:history"
          :tooltip="'Invoice history'|pgettext('Invoice')"
          size="sm"
          @click.prevent.stop="evh_397195341670858_clickPreventStop($event, {})"
        >
        </ItpButton>
      </ItpBox>
      <b-tab
        :title="'General'|gettext"
        class="container float-left"
      >
        <ItpRow
          v-if="tabManager.visited(0)"
        >
          <ItpCol
            w="6"
          >
            <UcMeterGeneralPanel
              :meter="item"
              :reload="lastLoaded"
              class="pb-4"
              @reload="evh_2679161326024595_reload($event, {})"
              @saved="evh_2679161326024595_saved($event, {})"
            >
            </UcMeterGeneralPanel>
            <UcRentalServices
              :meter="item"
              :reload="lastLoaded"
              v-if="item"
              @reload="evh_7987652045662005_reload($event, {})"
            >
            </UcRentalServices>
          </ItpCol>
          <ItpCol
            w="6"
          >
            <UcCommentsList
              :parent="item"
              :reload="lastLoaded"
              class="pb-4"
            >
            </UcCommentsList>
            <UcAttachmentsList
              :parent="item"
              :reload="lastLoaded"
              class="pb-4"
            >
            </UcAttachmentsList>
          </ItpCol>
        </ItpRow>
      </b-tab>
      <b-tab
        :title="'Readings'|pgettext('Meter')"
        class="container-fluid h-100"
      >
        <UcMeterReadings
          :meter="item"
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(1)"
        >
        </UcMeterReadings>
      </b-tab>
      <b-tab
        :title="'Consumptions'|pgettext('Meter')"
        class="container-fluid h-100"
        @reload="evh_6806515264385235_reload($event, {})"
      >
        <UcMeterConsumptions
          :meter="item"
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(2)"
        >
        </UcMeterConsumptions>
      </b-tab>
      <b-tab
        :title="'Auto Readings'|pgettext('Meter')"
        class="container-fluid h-100"
      >
        <UcMeterCharts
          :meter="item"
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(3)"
        >
        </UcMeterCharts>
      </b-tab>
      <b-tab
        :title="'Invoices'|pgettext('Meter')"
        class="container-fluid h-100"
      >
        <UcMeterInvoices
          :meter="item"
          :reload="lastLoaded"
          class="h-100"
          v-if="tabManager.visited(4)"
        >
        </UcMeterInvoices>
      </b-tab>
    </MaterialTabs>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "meter",
    path: "/meters/:id",
    component: "Meter",
    params: [{
      name: "id",
      prop: "meterId",
    }
      ,
    ]

  }
)

@Component()
export default class Meter extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  meterId!: string;

  @Watch('meterId')
  onMeter_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("meterId")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  tabManager!: any;

  async $$load_tabManager() {
    return new this.$app.utils.LazyTabManager()
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('read_meter', { asResource: true, parameters: { id: this.meterId } })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2285343489561581_to!: any;
  dataMembers = ['tabManager', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_2285343489561581_to'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        tabManager: null,
        item: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2285343489561581_to: {
          name: "app.meters",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.item.snapshot('serial_number')
          ,
        this.$fn.gettext("Meter")
          ,
        ]
        ,
        icon: this.item ? this.$config.meterTypes[this.item.meter_type].icon : this.$config.meter.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4396_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4396, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2095089031469157_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2095089031469157_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_9004123373732307_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_9004123373732307_success.executeFromDOM(this, event, scope);
  }

  async act_397195341670858_showModal_4402_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_397195341670858_showModal_4402, alias=undefined
    return {
      name: "entityEvents",
      props: {
        entityId: this.item.id,
      }
      ,
    }
  }

  async evh_397195341670858_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_397195341670858_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_2679161326024595_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2679161326024595_reload.executeFromDOM(this, event, scope);
  }

  async act_2679161326024595_setData_4406_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2679161326024595_setData_4406, alias=undefined
    return {
      path: "item",
      value: $event.data,
      resolve: false,
      noTouchLastLoaded: true,
      noTakeSnapshot: false,
    }
  }

  async evh_2679161326024595_saved(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2679161326024595_saved.executeFromDOM(this, event, scope);
  }

  async evh_7987652045662005_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7987652045662005_reload.executeFromDOM(this, event, scope);
  }

  async evh_6806515264385235_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6806515264385235_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4396: actions.CloseModalAction;
    evh_7315092382398562_close_4395: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2095089031469157_reloadComponentData_4398: actions.ReloadComponentDataAction;
    evh_2095089031469157_clickPreventStop_4397: actions.EventHandlerImpl;
    evh_2095089031469157_clickPreventStop: actions.EventHandlerGroup;
    act_9004123373732307_closeComponent_4400: actions.CloseComponentAction;
    evh_9004123373732307_success_4399: actions.EventHandlerImpl;
    evh_9004123373732307_success: actions.EventHandlerGroup;
    act_397195341670858_showModal_4402: actions.ShowModalAction;
    evh_397195341670858_clickPreventStop_4401: actions.EventHandlerImpl;
    evh_397195341670858_clickPreventStop: actions.EventHandlerGroup;
    act_2679161326024595_reloadComponentData_4404: actions.ReloadComponentDataAction;
    evh_2679161326024595_reload_4403: actions.EventHandlerImpl;
    evh_2679161326024595_reload: actions.EventHandlerGroup;
    act_2679161326024595_setData_4406: actions.SetDataAction;
    evh_2679161326024595_saved_4405: actions.EventHandlerImpl;
    evh_2679161326024595_saved: actions.EventHandlerGroup;
    act_7987652045662005_reloadComponentData_4408: actions.ReloadComponentDataAction;
    evh_7987652045662005_reload_4407: actions.EventHandlerImpl;
    evh_7987652045662005_reload: actions.EventHandlerGroup;
    act_6806515264385235_reloadComponentData_4410: actions.ReloadComponentDataAction;
    evh_6806515264385235_reload_4409: actions.EventHandlerImpl;
    evh_6806515264385235_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4396 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4396_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4395 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4396,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4395],
      }
    );
    const act_2095089031469157_reloadComponentData_4398 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_2095089031469157_clickPreventStop_4397 = new actions.EventHandlerImpl(
      {
        action: act_2095089031469157_reloadComponentData_4398,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_2095089031469157_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2095089031469157_clickPreventStop_4397],
      }
    );
    const act_9004123373732307_closeComponent_4400 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_9004123373732307_success_4399 = new actions.EventHandlerImpl(
      {
        action: act_9004123373732307_closeComponent_4400,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const evh_9004123373732307_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_9004123373732307_success_4399],
      }
    );
    const act_397195341670858_showModal_4402 = new actions.ShowModalAction(
      {
        actionArgs: this.act_397195341670858_showModal_4402_getActionArgs,
        events: [],
      }
    );
    const evh_397195341670858_clickPreventStop_4401 = new actions.EventHandlerImpl(
      {
        action: act_397195341670858_showModal_4402,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_397195341670858_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_397195341670858_clickPreventStop_4401],
      }
    );
    const act_2679161326024595_reloadComponentData_4404 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2679161326024595_reload_4403 = new actions.EventHandlerImpl(
      {
        action: act_2679161326024595_reloadComponentData_4404,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_2679161326024595_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_2679161326024595_reload_4403],
      }
    );
    const act_2679161326024595_setData_4406 = new actions.SetDataAction(
      {
        actionArgs: this.act_2679161326024595_setData_4406_getActionArgs,
        events: [],
      }
    );
    const evh_2679161326024595_saved_4405 = new actions.EventHandlerImpl(
      {
        action: act_2679161326024595_setData_4406,
        event: "saved",
        displayName: "setData",
      }
    );
    const evh_2679161326024595_saved = new actions.EventHandlerGroup(
      {
        handlers: [evh_2679161326024595_saved_4405],
      }
    );
    const act_7987652045662005_reloadComponentData_4408 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7987652045662005_reload_4407 = new actions.EventHandlerImpl(
      {
        action: act_7987652045662005_reloadComponentData_4408,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7987652045662005_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7987652045662005_reload_4407],
      }
    );
    const act_6806515264385235_reloadComponentData_4410 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_6806515264385235_reload_4409 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_reloadComponentData_4410,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_6806515264385235_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_6806515264385235_reload_4409],
      }
    );
    return {
      act_7315092382398562_closeModal_4396,
      evh_7315092382398562_close_4395,
      evh_7315092382398562_close,
      act_2095089031469157_reloadComponentData_4398,
      evh_2095089031469157_clickPreventStop_4397,
      evh_2095089031469157_clickPreventStop,
      act_9004123373732307_closeComponent_4400,
      evh_9004123373732307_success_4399,
      evh_9004123373732307_success,
      act_397195341670858_showModal_4402,
      evh_397195341670858_clickPreventStop_4401,
      evh_397195341670858_clickPreventStop,
      act_2679161326024595_reloadComponentData_4404,
      evh_2679161326024595_reload_4403,
      evh_2679161326024595_reload,
      act_2679161326024595_setData_4406,
      evh_2679161326024595_saved_4405,
      evh_2679161326024595_saved,
      act_7987652045662005_reloadComponentData_4408,
      evh_7987652045662005_reload_4407,
      evh_7987652045662005_reload,
      act_6806515264385235_reloadComponentData_4410,
      evh_6806515264385235_reload_4409,
      evh_6806515264385235_reload,
      reload: act_2095089031469157_reloadComponentData_4398,
    }
  }
}

Vue.component("Meter", Meter);

</script>